import mixpanel from 'mixpanel-browser';

import { LcmUserSession } from '../auth/types/next-auth';
import { AnalyticEvents } from '../types/AnalyticEvents';
import { isDevelopment } from '../utils/environments';

type MixPanelEvent = {
  event: AnalyticEvents;
  session?: LcmUserSession | null;
  properties?: Record<string, string | number | boolean | string[]>;
};

function initMixpanel() {
  const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;

  if (!MIXPANEL_TOKEN || isDevelopment()) {
    return;
  }

  mixpanel.init(MIXPANEL_TOKEN, {
    autocapture: false,
    track_pageview: true,
    persistence: 'localStorage',
    debug: false,
    record_sessions_percent: 100,
    record_idle_timeout_ms: 5 * 60 * 1000,
    record_mask_text_selector: '',
    record_block_selector: '',
    record_heatmap_data: true,
  });
}

function fireEvent({ event, properties, session }: MixPanelEvent) {
  if (!process.env.NEXT_PUBLIC_MIXPANEL_TOKEN || isDevelopment()) {
    return;
  }
  try {
    mixpanel.track(event, {
      ...properties,
      globalId: session?.user.globalId,
      band: session?.user.band,
      zone: session?.user.zone,
      roles: session?.user.roles,
      country: session?.user.country,
      isManager: session?.user.isManager,
      $name: session?.user.name,
    });
  } catch (err) {
    console.error(err);
  }
}

export const MixPanel = {
  fireEvent,
  initMixpanel,
};
